import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./pages/Scheduling/setupNavigationGuard";
import "react-toastify/dist/ReactToastify.css";

import App from "./App";
import "./index.css";
import "./styles/toastify-theme.css";
import "./utils/toastifyPatch";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
